// Email validation
export const validateEmail = (email: string): boolean => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

// Password validation
export const validatePassword = (password: string): boolean => {
  // Password must have at least 8 characters, one uppercase letter, one lowercase letter, and one number
  const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  return re.test(password);
};

// CPF validation
export const validateCpf = (cpf: string): boolean => {
  // Check if empty (optional)
  if (!cpf) return true;

  // Remove all non-numeric characters
  const numericCpf = cpf.replace(/\D/g, '');
  
  // Check if it has 11 digits
  return numericCpf.length === 11;
};

// CNPJ validation
export const validateCnpj = (cnpj: string): boolean => {
  // Check if empty (optional)
  if (!cnpj) return true;

  // Remove all non-numeric characters
  const numericCnpj = cnpj.replace(/\D/g, '');
  
  // Check if it has 14 digits
  return numericCnpj.length === 14;
};

// Phone validation
export const validatePhone = (phone: string): boolean => {
  // Check if empty (optional)
  if (!phone) return true;

  // Remove all non-numeric characters
  const numericPhone = phone.replace(/\D/g, '');
  
  // Check if it has between 10 and 11 digits
  return numericPhone.length >= 10 && numericPhone.length <= 11;
};